export enum LoadState {
  NOT_LOADED = 'Not Loaded',
  LOADING = 'Loading',
  LOADED = 'Loaded',
  FAILED = 'Failed',
}
